import Prompt from '@components/Prompt'
import { Titlebar } from '@components/Titlebar/Titlebar'
import Touchable from '@components/Touchable'
import { Box, Stack, Typography } from '@mui/material'
import React, { FC, useMemo, useState } from 'react'

interface Value {
  key: string
  humanValue: string
}

interface Props {
  heading: string
  values: Value[]
  currentValue: string
  onValueChange: (value: string) => void
}

const Picker: FC<Props> = ({ heading, values, currentValue, onValueChange }) => {
  const [pickerVisible, setPickerVisible] = useState(false)

  const onValueSelect = (value: Value) => {
    onValueChange(value.key)
    setPickerVisible(false)
  }

  const selectedValue = useMemo(() => {
    return values.find((value) => value.key === currentValue)
  }, [currentValue])

  return (
    <>
      <Touchable onClick={() => setPickerVisible(true)}>
        <Box
          sx={{
            background: (theme) =>
              currentValue
                ? theme.palette.background.rainbow
                : theme.palette.background.rainbowDisabled,
            borderRadius: 1,
            p: '2px',
          }}
        >
          <Box bgcolor="background.paper" p={2} borderRadius={1}>
            <Typography>{selectedValue?.humanValue || heading}</Typography>
          </Box>
        </Box>
      </Touchable>
      <Stack position="fixed" top={0} left={0} zIndex={5}>
        <Prompt show={pickerVisible} close={() => setPickerVisible(false)}>
          <Stack>
            <Titlebar title={heading} />
            <Stack spacing={0.5} maxHeight={300} overflow="scroll">
              {values.map((value) => (
                <Touchable key={value.key} onClick={() => onValueSelect(value)}>
                  <Box p={1} sx={{ '&:hover': { bgcolor: 'background.default' } }} borderRadius={1}>
                    <Typography>{value.humanValue}</Typography>
                  </Box>
                </Touchable>
              ))}
            </Stack>
          </Stack>
        </Prompt>
      </Stack>
    </>
  )
}

export default Picker
